import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "loyalty",
    name: "Loyalty",
    version: "0.1.0",
    tier: "addon",
    accent: "brand",
    dependsOn: ["sites"],
    description: "Lynked loyalty at a glance: members, new joiners, check-ins and the swipe rate against the tills, points and vouchers, the Lynked multibuys and shelf label offers live in store, and what members buy most. Read from Lynked each night and morning. Names are cut to \"First L.\" and emails are never kept.",
    permissions: {
        view: "See Lynked members, check-ins, promotions in store and what members buy at your sites",
        manage: "Set up the Lynked login and read from Lynked now",
    },
    grants: {
        "Head office": ["view", "manage"],
        "Area manager": ["view"],
        "Site manager": ["view"],
    },
    // The Lynked card on Home (the old dashboard had one; Jamie, 26/10/26 #39).
    widgets: [
        { key: "lynked", title: "Lynked loyalty", description: "Lynked members, new joiners, swipes and spend at your sites for the period, against the one before, and the busiest site.", group: "Customers", size: 1, permission: "view", defaultOn: true, order: 49 },
    ],
    nav: [
        { label: "Loyalty", path: "/loyalty", section: "shop", tab: "Promotions", tabIcon: "sparkle", permission: "view", icon: "heart", order: 40, blurb: "Lynked check-ins, swipe rate, offers in store" },
    ],
    // The systems it connects (the set-up tool's "Your systems"; moved from the platform's built-in list 29/10/26).
    integrations: [
        { id: "lynked", name: "Lynked", what: "Loyalty members and their transactions", service: "lynked", setup: ["loyalty/lynked", "loyalty/site-lynked"] },
    ],
    setup: [
        {
            id: "lynked", title: "Lynked login", scope: "tenant", blocking: false,
            why: "Nozl signs in to the Lynked portal each night to download the day's loyalty report, and each morning to read its dashboard, multibuy rules and shelf label offers. The password is kept in the vault. Names are cut to \"First L.\" and emails are never kept.",
            fields: [
                { key: "email", label: "Lynked portal email", type: "text", required: true },
                { key: "password", label: "Lynked portal password", type: "secret", required: true },
            ],
        },
        {
            id: "site-lynked", title: "Lynked location", scope: "site", blocking: false, after: ["loyalty/lynked"], when: { services: ["lynked"] },
            why: "The name Lynked uses for this site, so its loyalty transactions are counted here. Leave it blank to match by the site's name. The shelf label store code (Lynked → Integrations → Electronic Price Tags) is only needed when it doesn't end with the site's postcode.",
            fields: [
                { key: "location", label: "Lynked location name", type: "text", placeholder: "As it appears in Lynked" },
                { key: "tags", label: "Shelf label store code (optional)", type: "text", placeholder: "e.g. company_uk.ab12cd" },
            ],
        },
    ],
});
